const textStyles = 'font-family: Verdana,Arial,Helvetica,sans-serif; font-size: 11px; line-height: 1.2';

export const pageSizes = [
    { title: 'Letter', width: 216, height: 279 }, // mm
    { title: 'Legal', width: 216, height: 356 },
    { title: 'Executive', width: 184, height: 267 },
    { title: 'A5', width: 148, height: 210 },
    { title: 'B5', width: 182, height: 257 },
    { title: 'A4', width: 210, height: 297 },
    { title: 'B4', width: 257, height: 364 },
    { title: 'A3', width: 297, height: 420 }
];

export class EditorHelper {
    public static unwrapContent(content, margins = {}, pageSize = {}) {
        const matchedSize = content.match(/<style>@page \{size: ([^;}]+)/);
        if (matchedSize && matchedSize[1]) {
            const size = matchedSize[1].split(' ');
            pageSize['size'] = size[0] || 'A4';
            pageSize['orientation'] = size[1] || 'portrait';
        }

        const matched = content.match(/<body[^>]*>([\w|\W]*)<\/body>/im);
        if (matched && matched[1]) {
            content = matched[1];
        }

        try {
            const contentDom = document.createElement('div');
            contentDom.innerHTML = content;

            const wrappers = contentDom.getElementsByClassName('document-margin-wrap');
            if (wrappers.length) {
                const wrapper = <HTMLElement>wrappers[0];

                margins['top'] = parseInt(wrapper.style.paddingTop);
                margins['right'] = parseInt(wrapper.style.paddingRight);
                margins['bottom'] = parseInt(wrapper.style.paddingBottom);
                margins['left'] = parseInt(wrapper.style.paddingLeft);
                this.unwrap(wrapper);
            } else {
                margins['top'] = 0;
                margins['right'] = 0;
                margins['bottom'] = 0;
                margins['left'] = 0;
            }
            content = contentDom.innerHTML;
        } catch (e) {
            console.error(e);
        }
        return content;
    }

    private static unwrap(el: Element) {
        const parent = el.parentNode;
        while (el.firstChild) {
            parent.insertBefore(el.firstChild, el);
        }
        parent.removeChild(el);
    }

    public static wrapContent(content, margin = { top: 0, left: 0, right: 0, bottom: 0 }, pageSize = 'A4') {
        return `<html>
            <head>
            <style>@page {size: ${pageSize}; margin: 0;}</style>
            </head>
            <body>
            <div class="document-margin-wrap" style="padding: ${margin.top}mm ${margin.right}mm ${margin.bottom}mm ${margin.left}mm;${textStyles};">
            ${EditorHelper.clearContent(content)}
            </div>
            </body>
            </html>`;
    }

    public static clearContent(content: string) {
        let result = content
            .replace(/<canvas.*?><\/canvas>(<br>)*/g, '')
            .replace(/<p><\/p>/g, '')
            .replace(/<var[^>]*><\/var>/g, '')
            .replace(/(\r\n|\n|\r)/g, '')
            .trim();
        while (/^<p[^>]*>&nbsp;<\/p>|<p[^>]*>&nbsp;<\/p>$/g.test(result)) {
            result = result.replace(/^<p[^>]*>&nbsp;<\/p>|<p[^>]*>&nbsp;<\/p>$/g, '');
        }
        return result;
    }

    public static getPageSize(page) {
        let type = page.size || 'A4',
            orientation = page.orientation || 'portrait',
            result = { width: 210, height: 297 };
        const size = pageSizes.find(size => size.title === type);

        if (size) {
            result = orientation === 'landscape' ? { width: size.height, height: size.width } : { width: size.width, height: size.height };
        }

        return result;
    }
}
